import React from 'react';
import BannerSection from '../components/home/BannerSection';
import HeroSection from '../components/home/HeroSection';
import CategoriesSection from '../components/home/CategoriesSection';
import SegmentsSection from '../components/home/SegmentsSection';
import FeaturedProducts from '../components/home/FeaturedProducts';
import FeaturesSection from '../components/home/FeaturesSection';
import VideoShortsSection from '../components/home/VideoShortsSection';
import ShopGallerySection from '../components/home/ShopGallerySection';
import BlogSection from '../components/home/BlogSection';
import HomeFaqSection from '../components/home/HomeFaqSection';
import ShowroomMapSection from '../components/common/ShowroomMapSection';
import HelpCtaSection from '../components/home/HelpCtaSection';
import './HomePage.css';

const HomePage = () => {
    return (
        <div className="home-page">
            {/* 01 — DYNAMIC PROMOTIONAL BANNER SECTION */}
            <BannerSection />

            {/* 03 — HERO SECTION */}
            <HeroSection />

            {/* 04 — SHOP BY CATEGORY */}
            <CategoriesSection />

            {/* 06 — SHOP YOUR WAY */}
            <SegmentsSection />

            {/* 07 — FEATURED PRODUCTS */}
            <FeaturedProducts />

            {/* 08 — WHY CHOOSE RAHBER */}
            <FeaturesSection />

            {/* 09 — SHOWROOM REAL VIDEOS & SHORTS */}
            <VideoShortsSection />

            {/* 10 — AUTHENTIC SHOWROOM & PRODUCT DISPLAYS GALLERY */}
            <ShopGallerySection />

            {/* 11 — BLOG / BUYING GUIDES */}
            <BlogSection />

            {/* 12 — FAQ */}
            <HomeFaqSection />

            {/* 13 — FLAGSHIP SHOWROOM MAP & DIRECTIONS (RISEUP STYLE) */}
            <ShowroomMapSection />

            {/* 14 — HELP / CONTACT CTA */}
            <HelpCtaSection />
        </div>
    );
};

export default HomePage;
